import React from "react"

import { ChildSelector } from "../../helpers/ChildSelector"

import WPImage, { DISPLAY_MODE } from "../_base/WPImage"

import * as invitationStyles from "../../styles/world_championships/InvitationOnly.module.css"

import { AirtableApi } from "../../helpers/AirtableApi"

const InvitationOnly = props => {
  const { airtableToken, airtableBaseId, airtableTableName } = props

  const [, forceUpdate] = React.useReducer(x => x + 1, 0)

  const [formData, setFormData] = React.useState({
    email: "",
    name: "",
    company: "",
  })

  const [isSubmitted, setSubmitted] = React.useState(false)
  const [hasError, setHasError] = React.useState(false)
  const [isSubmitting, setIsSubmitting] = React.useState(false)

  const handleItemChange = evt => {
    let updated = { ...formData }
    updated[evt.target.name] = evt.target.value

    setFormData(updated)
    forceUpdate()
  }

  const handleSubmit = async evt => {
    evt.preventDefault()

    setHasError(false)
    setIsSubmitting(true)

    try {
      const submissionData = {
        ...formData,
        when: new Date().toISOString().slice(0, 10),
      }

      await AirtableApi.writeRecord(
        airtableToken,
        airtableBaseId,
        airtableTableName,
        submissionData,
      )

      setHasError(false)
      setSubmitted(true)
      setIsSubmitting(false)
    } catch (error) {
      console.error(error)

      setHasError(true)
      setIsSubmitting(false)
    }
  }
  return (
    <div className="container-fluid">
      <div className={`row ${invitationStyles.wrapper}`}>
        <div className={`col-12`}>
          <div
            className={`row g-0 justify-content-center ${invitationStyles.contentWrapper}`}
          >
            <div className={`col-lg-10 col-12 ${invitationStyles.content}`}>
              {!isSubmitted ? (
                <>
                  <div className={`row g-0 ${invitationStyles.row}`}>
                    <div className={`col-12 ${invitationStyles.formArea}`}>
                      <form
                        className={`d-flex flex-column flex-md-row align-items-center ${invitationStyles.invitationForm}`}
                        onSubmit={handleSubmit}
                      >
                        <div
                          className={`mb-3 mb-md-0 me-md-3 w-100 w-md-auto ${invitationStyles.formField}`}
                        >
                          <input
                            id="email"
                            type="email"
                            className="form-control"
                            placeholder="Email *"
                            aria-label="email"
                            name="email"
                            value={formData.email}
                            required
                            onChange={handleItemChange}
                          />
                        </div>
                        <div
                          className={`mb-3 mb-md-0 me-md-3 w-100 w-md-auto ${invitationStyles.formField}`}
                        >
                          <input
                            id="company"
                            type="text"
                            className="form-control"
                            placeholder="Company *"
                            aria-label="company"
                            name="company"
                            required
                            value={formData.company}
                            onChange={handleItemChange}
                          />
                        </div>
                        <div
                          className={`mb-3 mb-md-0 me-md-3 w-100 w-md-auto ${invitationStyles.formField}`}
                        >
                          <input
                            id="name"
                            type="text"
                            className="form-control"
                            placeholder="Name (optional)"
                            aria-label="name"
                            name="name"
                            value={formData.name}
                            onChange={handleItemChange}
                          />
                        </div>

                        <div
                          className={`w-100 w-md-auto ${invitationStyles.submitButtonWrapper}`}
                        >
                          <button
                            type="submit"
                            className={`w-100 ${invitationStyles.submitButton}`}
                            disabled={isSubmitting}
                          >
                            {isSubmitting
                              ? "Submitting..."
                              : "Request Invitation"}
                          </button>
                          {hasError && (
                            <p className={invitationStyles.errorMessage}>
                              An unexpected error has occurred. Please confirm
                              all data to be correctly input and try again...
                            </p>
                          )}
                        </div>
                      </form>
                    </div>
                  </div>
                </>
              ) : (
                <div className={`row g-0 ${invitationStyles.row}`}>
                  <div className={`col-12 ${invitationStyles.successMessage}`}>
                    <h4>Thank you for your interest!</h4>
                    <p>
                      We have received your invitation request. We will review
                      your information and get back to you soon.
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default InvitationOnly
